import { useThrottleEffect } from 'ahooks';
import { getLang } from 'lowcomp/plugins/member/utils';
import React, { useEffect } from 'react';
import { Navigation, Pagination } from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/react';
import { PointsBehaviorValue } from '../config';
import { TextLang } from '../TextLang';
import css from './index.module.scss';
import SubscribeModal from './SubscribeModal';
import { usePoints } from './usePoints';
import { useGlobal } from '@/utils/useGlobal';
import { getUserPointsByActions } from '@/service/vip';
import { isMembersFestival } from '@/utils/membersFestival';
import { hasReferralLocale } from '@/constants/appreciationDay';
import {
    ReferralIcon,
    RightFacebook,
    RightFollow,
    RightIcon,
    RightIns,
    RightKakoo,
    RightX,
    RightYoutube,
    WaysEarnIcon,
    WaysProfileIcon,
    WaysRedeemIcon,
    WaysSignUpIcon,
    WaysWarrantyIcon,
} from '@/components/UI/svg/Ecocredits/WaysIcons';
import { EFQuestionMark2 } from '@/components/UI/svg/Ecocredits';
import EfModal from '@/components/UI/Modal';
import Button from '@/components/UI/Button';
import { useEcoStore } from 'lowcode/utils/context/ecocredits';
import { message } from '@/components/UI/Message';
import { signupCookie } from '@/utils/cookies/signupCookie';
import gtm from '@/utils/gtm';
import LoginFormModal from '@/components/LoginFormModal';
import { createPortal } from 'react-dom';

interface props {
    isLogin: boolean;
    rewardEarnRule: any[];
    refershData: () => void;
    data: any;
}

const WaysToEarnPoints: React.FC<props> = ({ isLogin, rewardEarnRule, refershData, data }) => {
    const { Link, useRouter, useState, isMobile, subEmailCount } = useGlobal();
    const router = useRouter();
    const { locale } = router;
    const t = getLang(TextLang, locale);
    const { inBlackList } = useEcoStore();

    const newWayType = 'wayType';
    const pageId = 'WAYS_TO_EARN_POINTS';

    const [profileModalOpen, setProfileModalOpen] = useState(false);
    const [subscribeModalOpen, setSubscribeModalOpen] = useState(false);
    const [swiper, setSwiper] = useState({});
    const [num, setNum] = useState(0);
    const [showLoginModal, setShowLoginModal] = useState(false);
    const [showLoginModal1, setShowLoginModal1] = useState(false);
    const [isClient, setIsClient] = useState(false);

    const birthdayRule = rewardEarnRule.find((rule) => rule.source2 === 'ACCOUNT_INFO_BIRTHDAY');
    const birthdayIsFinish = !birthdayRule || birthdayRule?.isFinish === 1;
    const profileIsFinish = rewardEarnRule?.filter((rule) => rule.source === 'ACCOUNT_INFO')?.every((rule) => rule?.isFinish === 1);
    const subscribeRule = rewardEarnRule.find((rule) => rule.source2 === 'EDM');
    const subscribeIsFinish = !subscribeRule || subscribeRule?.isFinish === 1;
    const warrantyRule = rewardEarnRule.find((rule) => rule.source2 === 'WARRANTY');
    const warrantyIsFinish = !warrantyRule || warrantyRule?.isFinish === 1;
    const instagramRule = rewardEarnRule.find((rule) => rule.source2 === 'ATTENTION_INSTAGRAM');
    const instagramIsFinish = !instagramRule || instagramRule?.isFinish === 1;
    const xRule = rewardEarnRule.find((rule) => rule.source2 === 'ATTENTION_X');
    const xIsFinish = !xRule || xRule?.isFinish === 1;
    const tiktokRule = rewardEarnRule.find((rule) => rule.source2 === 'ATTENTION_TITTOK');
    const tiktokIsFinish = !tiktokRule || tiktokRule?.isFinish === 1;
    const youtubeRule = rewardEarnRule.find((rule) => rule.source2 === 'ATTENTION_YOUTUBE');
    const youtubeIsFinish = !youtubeRule || youtubeRule?.isFinish === 1;
    const facebookRule = rewardEarnRule.find((rule) => rule.source2 === 'ATTENTION_FACEBOOK');
    const facebookIsFinish = !facebookRule || facebookRule?.isFinish === 1;
    const lineRule = rewardEarnRule.find((rule) => rule.source2 === 'ATTENTION_LINE');
    const lineIsFinish = !lineRule || lineRule?.isFinish === 1;
    const kakooRule = rewardEarnRule.find((rule) => rule.source2 === 'ATTENTION_KAKOO');
    const kakooIsFinish = !kakooRule || kakooRule?.isFinish === 1;
    const jFackbookRule = rewardEarnRule.find((rule) => rule.source2 === 'JOIN_FACEBOOK');
    const jFackbookIsFinish = !jFackbookRule || jFackbookRule?.isFinish === 1;
    const jKakooRule = rewardEarnRule.find((rule) => rule.source2 === 'JOIN_KAKOO');
    const jKakooIsFinish = !jKakooRule || jKakooRule?.isFinish === 1;
    const mfStatus = isMembersFestival(locale);

    const statusMap: Record<string, boolean> = !isLogin
        ? {
              sign_up: false,
              birthday: false,
              profile: false,
              subscribe: false,
              warranty: false,
              ATTENTION_INSTAGRAM: false,
              ATTENTION_X: false,
              ATTENTION_TITTOK: false,
              ATTENTION_YOUTUBE: false,
              ATTENTION_FACEBOOK: false,
              ATTENTION_LINE: false,
              ATTENTION_KAKOO: false,
              JOIN_FACEBOOK: false,
              JOIN_KAKOO: false,
          }
        : {
              sign_up: true,
              birthday: birthdayIsFinish,
              profile: profileIsFinish,
              subscribe: subscribeIsFinish,
              warranty: warrantyIsFinish,
              ATTENTION_INSTAGRAM: instagramIsFinish,
              ATTENTION_X: xIsFinish,
              ATTENTION_TITTOK: tiktokIsFinish,
              ATTENTION_YOUTUBE: youtubeIsFinish,
              ATTENTION_FACEBOOK: facebookIsFinish,
              ATTENTION_LINE: lineIsFinish,
              ATTENTION_KAKOO: kakooIsFinish,
              JOIN_FACEBOOK: jFackbookIsFinish,
              JOIN_KAKOO: jKakooIsFinish,
          };

    const addQueryParam = (type: string) => {
        const currentUrl = window.location.href;
        const url = new URL(currentUrl);
        url.searchParams.set(newWayType, type);
        url.hash = pageId;
        return url;
    };

    const removeQueryParam = () => {
        const currentUrl = window.location.href;
        const url = new URL(currentUrl);
        url.searchParams.delete(newWayType);
        window.history.replaceState({}, '', url);
    };

    // 每一个元素的状态（即hover展示的内容）由 登陆状态 & statusMap共同决定
    const defaultData = [
        {
            // 未登陆 / 已登陆
            key: 'sign_up',
            title: t('sign_up'),
            text: mfStatus === 0 ? t('sign_up_desc_h_1') : t('sign_up_desc_h'),
            highlighttext: mfStatus === 0 ? t('sign_up1_1') : t('sign_up1'),
            icon: <WaysSignUpIcon />,
            uncomplate: {
                desc: t('subscribe_hover'),
                button: t('sign_up'),
                onClick: () => {
                    signupCookie?.({
                        sector_name: t('earn_points_title'),
                        entry_position: 5,
                    });
                    gtm.push({
                        event: 'uaEvent',
                        event_name: 'signup_start',
                        entry_type: 'section entry',
                        entry_position: t('earn_points_title'),
                        entry_name: t('sign_up_desc_h'),
                        source_channel: 'Website',
                    });

                    console.log('--------');
                    console.log({ data });

                    if (data.loginType === 'modal') {
                        setShowLoginModal1(true);
                    } else {
                        router.push(`/register?redirect=${encodeURIComponent(window.location.href)}`);
                    }
                },
            },
        },
        {
            // 未登陆 / 未完成 / 已完成
            key: 'subscribe',
            title: t('subscribe'),
            text: t('subscribe_text'),
            highlighttext: t('subscribe1'),
            icon: <WaysEarnIcon />,
            uncomplate: {
                desc: t('subscribe_hover'),
                button: t('subscribe_capital_letters'),
                onClick: () => {
                    if (!isLogin) {
                        signupCookie?.({
                            sector_name: t('earn_points_title'),
                            entry_position: 5,
                        });
                        gtm.push({
                            event: 'uaEvent',
                            event_name: 'activity_join_login',
                            button_name: `${t('subscribe_text')}_${t('subscribe_capital_letters')}`,
                        });
                        const newUrl = addQueryParam('subscribe');

                        if (data.loginType === 'modal') {
                            setShowLoginModal(true);
                        } else {
                            router.push(`/login?redirect=${encodeURIComponent(newUrl.href)}`);
                        }
                    } else {
                        setSubscribeModalOpen(true);
                    }
                },
            },
        },
        {
            // 未登陆 / 已登陆
            key: 'shop',
            title: t('shop_capital_letters'),
            text: t('earn_point_by_order'),
            highlighttext: t('shop1'),
            icon: <WaysRedeemIcon />,
            uncomplate: {
                desc: t('earn_point_rule_shop'),
                button: t('shop_capital_letters'),
                onClick: () => {
                    if (!isLogin) {
                        signupCookie?.({
                            sector_name: t('earn_points_title'),
                            entry_position: 5,
                        });
                        gtm.push({
                            event: 'uaEvent',
                            event_name: 'activity_join_login',
                            button_name: `${t('earn_point_by_order')}_${t('shop_capital_letters')}`,
                        });
                        if (data.loginType === 'modal') {
                            setShowLoginModal(true);
                        } else {
                            router.push(`/login?redirect=${encodeURIComponent(`/${locale}/`)}`);
                        }
                    } else {
                        gtm.push({
                            event: 'uaEvent',
                            event_name: 'jump_button',
                            position: 'Inpage',
                            button_name: `${t('earn_point_by_order')}_${t('shop_capital_letters')}`,
                            url: `/${locale}`,
                        });
                        router.push(`/${locale}`);
                    }
                },
            },
        },
        {
            // 未登陆 / 已登陆
            key: 'warranty',
            title: t('warranty_capital_letters'),
            text: t('warranty_desc1'),
            highlighttext: t('warranty1'),
            icon: <WaysWarrantyIcon />,
            uncomplate: {
                desc: t('warranty1'),
                button: t('warranty_capital_letters'),
                onClick: () => {
                    if (!isLogin) {
                        signupCookie?.({
                            sector_name: t('earn_points_title'),
                            entry_position: 5,
                        });
                        gtm.push({
                            event: 'uaEvent',
                            event_name: 'activity_join_login',
                            button_name: `${t('warranty_desc1')}_${t('warranty_capital_letters')}`,
                        });
                        const newUrl = addQueryParam('warranty');
                        if (data.loginType === 'modal') {
                            setShowLoginModal(true);
                        } else {
                            router.push(`/login?redirect=${encodeURIComponent(newUrl.href)}`);
                        }
                    } else {
                        gtm.push({
                            event: 'uaEvent',
                            event_name: 'jump_button',
                            position: 'Inpage',
                            button_name: `${t('warranty_desc1')}_${t('warranty_capital_letters')}`,
                            url: `/${locale}/support/warranty`,
                        });
                        if (inBlackList) return message.error(t('not_eligible'));
                        router.push(`/${locale}/support/warranty`);
                    }
                },
            },
        },
        {
            // 未登陆 / 未完成 / 已完成
            key: 'profile',
            title: t('profile'),
            text: t('profile_desc1'),
            highlighttext: t('profile1'),
            icon: <WaysProfileIcon />,
            uncomplate: {
                desc: t('profile_desc2'),
                learn_more: t('learn_more'),
                button: t('profile'),
                onClick: () => {
                    if (!isLogin) {
                        signupCookie?.({
                            sector_name: t('earn_points_title'),
                            entry_position: 5,
                        });
                        gtm.push({
                            event: 'uaEvent',
                            event_name: 'activity_join_login',
                            button_name: `${t('profile_desc1')}_${t('profile')}`,
                        });
                        const newUrl = addQueryParam('profile');
                        if (data.loginType === 'modal') {
                            setShowLoginModal(true);
                        } else {
                            router.push(`/login?redirect=${encodeURIComponent(newUrl.href)}`);
                        }
                    } else {
                        gtm.push({
                            event: 'uaEvent',
                            event_name: 'jump_button',
                            position: 'Inpage',
                            button_name: `${t('profile_desc1')}_${t('profile')}`,
                            url: `/${locale}/my-overview`,
                        });
                        router.push(`/${locale}/my-overview`);
                    }
                },
            },
        },
    ];

    if (hasReferralLocale.includes(locale)) {
        defaultData.push({
            key: 'referral',
            title: t('referral'),
            text: t('referral_desc'),
            highlighttext: t('referral1'),
            icon: <ReferralIcon />,
            uncomplate: {
                desc: t('referral_desc'),
                button: t('referral'),
                onClick: () => {
                    gtm.push({
                        event: 'uaEvent',
                        event_name: 'jump_button',
                        position: 'Inpage',
                        button_name: `${t('referral_desc')}_${t('referral')}`,
                        url: `/${locale}/referral`,
                    });
                    router.push(`/${locale}/referral`);
                },
            },
        });
    }

    const dataForSlide = (data: any) => {
        const chunks = [];
        for (let i = 0; i < data.length; i += 6) {
            const chunk = data.slice(i, i + 6);
            chunks.push(chunk);
        }
        return chunks;
    };

    const [slideData, setSlideData] = useState(dataForSlide(defaultData));
    const { actionPoints, fetchPointtCards } = usePoints(locale);
    const [activeIndex, setActiveIndex] = useState(0);

    const pollingData = () => {
        const delayTimer = [3, 5];
        delayTimer.forEach((timer) => {
            setTimeout(() => {
                refershData && refershData();
            }, timer * 1000);
        });
    };

    const getPoints = async (source: string) => {
        return await getUserPointsByActions({ source }, locale);
    };

    const generatePointsText = (points?: string, tag?: string) => {
        return t.rich(tag, {
            points: points || '0',
        });
    };

    const handleResult = (res: any) => {
        if (res.code !== '0') return;
        fetchPointtCards(isLogin);
    };

    const handleSlideChange = (swiper: any) => {
        if (num === 0) {
            setTheStyles();
            setNum(1);
        }
        setActiveIndex(swiper.realIndex);
    };

    const handleNext = () => {
        swiper.slideTo(1);
    };

    const handlePrev = () => {
        swiper.slideTo(0);
    };

    const getInsUrl = (locale: string) => {
        const followUrlMaps: Record<string, string> = {
            us: 'https://www.instagram.com/ecoflowtech/',
            ca: 'https://www.instagram.com/ecoflowtech/',
            eu: 'https://www.instagram.com/ecoflowtech/',
            uk: 'https://www.instagram.com/ecoflowtech/',
            de: 'https://www.instagram.com/ecoflow.deutschland/',
            it: 'https://www.instagram.com/ecoflow.italia/',
            fr: 'https://www.instagram.com/ecoflow.france/',
            es: 'https://www.instagram.com/ecoflow.espana/',
            jp: 'https://www.instagram.com/ecoflowjapan/',
            za: 'https://www.instagram.com/ecoflow.southafrica/',
            au: 'https://www.instagram.com/ecoflow.australia/',
            kr: 'https://www.instagram.com/ecoflow_korea/',
            br: 'https://www.instagram.com/ecoflowtech/',
            mx: 'https://www.instagram.com/ecoflow_mexico/',
            ph: 'https://www.instagram.com/ecoflowtech/',
        };

        return followUrlMaps[locale] || followUrlMaps['us'];
    };

    const refreshTimer = () => {
        setTimeout(() => {
            refershData && refershData();
        }, 1000);
    };

    const cmdFunc: Record<string, () => void> = {
        [PointsBehaviorValue.ATTENTION_INSTAGRAM]: () => {
            if (!isLogin) {
                const newUrl = addQueryParam('instagram');
                signupCookie?.({
                    sector_name: t('earn_points_title'),
                    entry_position: 5,
                });
                gtm.push({
                    event: 'uaEvent',
                    event_name: 'activity_join_login',
                    button_name: actionPoints
                        ? `${generatePointsText(actionPoints[PointsBehaviorValue.ATTENTION_INSTAGRAM]?.value, 'ins_desc1')}_${t('ins_title')}`
                        : '',
                });
                if (data.loginType === 'modal') {
                    setShowLoginModal(true);
                } else {
                    router.push(`/login?redirect=${encodeURIComponent(newUrl.href)}`);
                }
                return;
            }
            gtm.push({
                event: 'uaEvent',
                event_name: 'activity_join_social',
                method: 'Instagram',
                position: `${actionPoints ? generatePointsText(actionPoints[PointsBehaviorValue.ATTENTION_INSTAGRAM]?.value, 'ins_desc1') : ''}_${t(
                    'ins_title',
                )}`,
                button_name: t('ins_title'),
            });
            getPoints(PointsBehaviorValue.ATTENTION_INSTAGRAM)
                .then(handleResult)
                .then(() => {
                    refreshTimer();

                    const url = getInsUrl(locale);
                    window.open(url, '_blank');
                });
        },
        [PointsBehaviorValue.ATTENTION_X]: () => {
            if (!isLogin) {
                const newUrl = addQueryParam('x');
                signupCookie?.({
                    sector_name: t('earn_points_title'),
                    entry_position: 5,
                });
                gtm.push({
                    event: 'uaEvent',
                    event_name: 'activity_join_login',
                    button_name: actionPoints ? `${generatePointsText(actionPoints[PointsBehaviorValue.ATTENTION_X]?.value, 'x_desc1')}_${t('x_title')}_1` : '',
                });
                if (data.loginType === 'modal') {
                    setShowLoginModal(true);
                } else {
                    router.push(`/login?redirect=${encodeURIComponent(newUrl.href)}`);
                }
                return;
            }
            gtm.push({
                event: 'uaEvent',
                event_name: 'activity_join_social',
                method: 'X',
                position: `${actionPoints ? generatePointsText(actionPoints[PointsBehaviorValue.ATTENTION_X]?.value, 'x_desc1') : ''}_${t('x_title')}_1`,
                button_name: t('x_title'),
            });
            getPoints(PointsBehaviorValue.ATTENTION_X)
                .then(handleResult)
                .then(() => {
                    refreshTimer();

                    const url = locale === 'jp' ? 'https://twitter.com/EcoflowJapan/' : 'https://x.com/EcoFlowTech';
                    window.open(url, '_blank');
                });
        },
        [PointsBehaviorValue.ATTENTION_YOUTUBE]: () => {
            if (!isLogin) {
                const newUrl = addQueryParam('youtube');
                signupCookie?.({
                    sector_name: t('earn_points_title'),
                    entry_position: 5,
                });
                gtm.push({
                    event: 'uaEvent',
                    event_name: 'activity_join_login',
                    button_name: actionPoints
                        ? `${generatePointsText(actionPoints[PointsBehaviorValue.ATTENTION_YOUTUBE]?.value, 'youtube_desc1')}_${t('youtube_title')}`
                        : '',
                });
                if (data.loginType === 'modal') {
                    setShowLoginModal(true);
                } else {
                    router.push(`/login?redirect=${encodeURIComponent(newUrl.href)}`);
                }
                return;
            }
            gtm.push({
                event: 'uaEvent',
                event_name: 'activity_join_social',
                method: 'YouTube',
                position: `${actionPoints ? generatePointsText(actionPoints[PointsBehaviorValue.ATTENTION_YOUTUBE]?.value, 'youtube_desc1') : ''}_${t(
                    'youtube_title',
                )}`,
                button_name: t('youtube_title'),
            });
            getPoints(PointsBehaviorValue.ATTENTION_YOUTUBE)
                .then(handleResult)
                .then(() => {
                    const followUrlMaps: Record<string, string> = {
                        us: 'https://www.youtube.com/@EcoFlowTech/',
                        ca: 'https://www.youtube.com/@EcoFlowTech/',
                        eu: 'https://www.youtube.com/@EcoFlowTech/',
                        uk: 'https://www.youtube.com/@EcoFlowTech/',
                        de: 'https://www.youtube.com/@EcoFlowDeutschland',
                        jp: 'https://www.youtube.com/channel/UCup-8KjYcdzZf6iP583Q5FQ',
                    };

                    refreshTimer();

                    const url = followUrlMaps[locale] || followUrlMaps['us'];
                    window.open(url, '_blank');
                });
        },
        [PointsBehaviorValue.ATTENTION_FACEBOOK]: () => {
            if (!isLogin) {
                const newUrl = addQueryParam('facebook');
                signupCookie?.({
                    sector_name: t('earn_points_title'),
                    entry_position: 5,
                });
                gtm.push({
                    event: 'uaEvent',
                    event_name: 'activity_join_login',
                    button_name: actionPoints
                        ? `${generatePointsText(actionPoints[PointsBehaviorValue.ATTENTION_FACEBOOK]?.value, 'facebook_desc1')}_${t('facebook_title')}`
                        : '',
                });
                if (data.loginType === 'modal') {
                    setShowLoginModal(true);
                } else {
                    router.push(`/login?redirect=${encodeURIComponent(newUrl.href)}`);
                }
                return;
            }
            gtm.push({
                event: 'uaEvent',
                event_name: 'activity_join_social',
                method: 'Facebook',
                position: `${actionPoints ? generatePointsText(actionPoints[PointsBehaviorValue.ATTENTION_FACEBOOK]?.value, 'facebook_desc1') : ''}_${t(
                    'facebook_title',
                )}`,
                button_name: t('facebook_title'),
            });
            getPoints(PointsBehaviorValue.ATTENTION_FACEBOOK)
                .then(handleResult)
                .then(() => {
                    const followUrlMaps: Record<string, string> = {
                        us: 'https://www.facebook.com/ecoflowtech',
                        ca: 'https://www.facebook.com/ecoflowtech',
                        eu: 'https://www.facebook.com/ecoflowtech',
                        uk: 'https://www.facebook.com/ecoflowtech',
                        de: 'https://www.facebook.com/EcoFlowDeutschland/',
                        it: 'https://www.facebook.com/EcoFlowItalia/',
                        fr: 'https://www.facebook.com/EcoFlowFrance',
                        es: 'https://www.facebook.com/EcoFlowEspana/',
                        jp: 'https://www.facebook.com/EcoFlowJapan/',
                        za: 'https://www.facebook.com/ecoflowaustralia/',
                        au: 'https://www.facebook.com/ecoflowtech',
                        br: 'https://www.facebook.com/EcoFlowLatam',
                        mx: 'https://www.facebook.com/EcoFlowLatam',
                        ph: 'https://www.facebook.com/EcoFlowGlobal/',
                    };

                    refreshTimer();

                    const url = followUrlMaps[locale] || followUrlMaps['us'];
                    window.open(url, '_blank');
                });
        },
        [PointsBehaviorValue.ATTENTION_LINE]: () => {
            if (!isLogin) {
                const newUrl = addQueryParam('line');
                signupCookie?.({
                    sector_name: t('earn_points_title'),
                    entry_position: 5,
                });
                gtm.push({
                    event: 'uaEvent',
                    event_name: 'activity_join_login',
                    button_name: actionPoints
                        ? `${generatePointsText(actionPoints[PointsBehaviorValue.ATTENTION_LINE]?.value, 'line_desc1')}_${t('line_title')}`
                        : '',
                });
                if (data.loginType === 'modal') {
                    setShowLoginModal(true);
                } else {
                    router.push(`/login?redirect=${encodeURIComponent(newUrl.href)}`);
                }
                return;
            }
            gtm.push({
                event: 'uaEvent',
                event_name: 'activity_join_social',
                method: 'Line',
                position: `${actionPoints ? generatePointsText(actionPoints[PointsBehaviorValue.ATTENTION_LINE]?.value, 'line_desc1') : ''}_${t('line_title')}`,
                button_name: t('line_title'),
            });
            getPoints(PointsBehaviorValue.ATTENTION_LINE)
                .then(handleResult)
                .then(() => {
                    refreshTimer();

                    window.open('https://lin.ee/DkXvQw2', '_blank');
                });
        },
        [PointsBehaviorValue.ATTENTION_KAKOO]: () => {
            if (!isLogin) {
                const newUrl = addQueryParam('kakoo');
                signupCookie?.({
                    sector_name: t('earn_points_title'),
                    entry_position: 5,
                });
                gtm.push({
                    event: 'uaEvent',
                    event_name: 'activity_join_login',
                    button_name: actionPoints
                        ? `${generatePointsText(actionPoints[PointsBehaviorValue.ATTENTION_KAKOO]?.value, 'kakoo_desc1')}_${t('kakoo_title')}`
                        : '',
                });
                if (data.loginType === 'modal') {
                    setShowLoginModal(true);
                } else {
                    router.push(`/login?redirect=${encodeURIComponent(newUrl.href)}`);
                }
                return;
            }
            gtm.push({
                event: 'uaEvent',
                event_name: 'activity_join_social',
                method: 'Line',
                position: `${actionPoints ? generatePointsText(actionPoints[PointsBehaviorValue.ATTENTION_KAKOO]?.value, 'kakoo_desc1') : ''}_${t(
                    'kakoo_title',
                )}`,
                button_name: t('kakoo_title'),
            });
            getPoints(PointsBehaviorValue.ATTENTION_KAKOO)
                .then(handleResult)
                .then(() => {
                    refreshTimer();

                    window.open('https://pf.kakao.com/_KhFRG', '_blank');
                });
        },
        [PointsBehaviorValue.JOIN_FACEBOOK]: () => {
            if (!isLogin) {
                const newUrl = addQueryParam('joinfacebook');
                signupCookie?.({
                    sector_name: t('earn_points_title'),
                    entry_position: 5,
                });
                gtm.push({
                    event: 'uaEvent',
                    event_name: 'activity_join_login',
                    button_name: actionPoints
                        ? `${generatePointsText(actionPoints[PointsBehaviorValue.JOIN_FACEBOOK]?.value, 'joininfacebook_desc1')}_${t('joininfacebook_title')}`
                        : '',
                });
                if (data.loginType === 'modal') {
                    setShowLoginModal(true);
                } else {
                    router.push(`/login?redirect=${encodeURIComponent(newUrl.href)}`);
                }
                return;
            }
            gtm.push({
                event: 'uaEvent',
                event_name: 'activity_join_social',
                method: 'Line',
                position: `${actionPoints ? generatePointsText(actionPoints[PointsBehaviorValue.JOIN_FACEBOOK]?.value, 'joininfacebook_desc1') : ''}_${t(
                    'joininfacebook_title',
                )}`,
                button_name: t('joininfacebook_title'),
            });
            getPoints(PointsBehaviorValue.JOIN_FACEBOOK)
                .then(handleResult)
                .then(() => {
                    const followUrlMaps: Record<string, string> = {
                        eu: 'https://www.facebook.com/groups/ecoflowclub',
                        uk: 'https://bit.ly/UK_FBGroup',
                        de: 'http://bit.ly/3Kis0MT',
                        it: 'https://bit.ly/3QjaD1w',
                        fr: 'http://bit.ly/40uEw1h',
                        es: 'https://www.facebook.com/groups/ecoflowclub',
                        za: 'https://www.facebook.com/groups/efsouthafrica',
                        br: 'https://www.facebook.com/groups/ecoflowclub',
                        mx: 'https://www.facebook.com/groups/ecoflowclub',
                        ph: 'https://www.facebook.com/groups/ecoflowclub',
                    };

                    refreshTimer();

                    const url = followUrlMaps[locale];
                    window.open(url, '_blank');
                });
        },
    };

    useThrottleEffect(() => {
        if (subEmailCount === 0) return;
        pollingData();
    }, [subEmailCount]);

    useEffect(() => {
        if (actionPoints) {
            const instagram = {
                key: PointsBehaviorValue.ATTENTION_INSTAGRAM,
                title: t('ins_title'),
                text: generatePointsText(actionPoints[PointsBehaviorValue.ATTENTION_INSTAGRAM]?.value, 'ins_desc1'),
                highlighttext: t('ins'),
                icon: <RightIns />,
                isFinish: !!actionPoints[PointsBehaviorValue.ATTENTION_INSTAGRAM]?.isFinish,
                uncomplate: {
                    desc: generatePointsText(actionPoints[PointsBehaviorValue.ATTENTION_INSTAGRAM]?.value, 'ins_desc2'),
                    // button: locale !== 'jp' ? t('follow_button') : t('follow_button_ins'),
                    button: t('ins_title'),
                    onClick: () => {},
                },
            };

            const x = {
                key: PointsBehaviorValue.ATTENTION_X,
                title: t('x_title'),
                text: generatePointsText(actionPoints[PointsBehaviorValue.ATTENTION_X]?.value, 'x_desc1'),
                highlighttext: t('x'),
                icon: <RightX />,
                isFinish: !!actionPoints[PointsBehaviorValue.ATTENTION_X]?.isFinish,
                uncomplate: {
                    desc: generatePointsText(actionPoints[PointsBehaviorValue.ATTENTION_X]?.value, 'x_desc2'),
                    // button: locale !== 'jp' ? t('follow_button') : t('follow_button_x'),
                    button: t('x_title'),
                    onClick: () => {},
                },
            };

            const youtube = {
                key: PointsBehaviorValue.ATTENTION_YOUTUBE,
                title: t('youtube_title'),
                text: generatePointsText(actionPoints[PointsBehaviorValue.ATTENTION_YOUTUBE]?.value, 'youtube_desc1'),
                highlighttext: t('youtube'),
                icon: <RightYoutube />,
                isFinish: !!actionPoints[PointsBehaviorValue.ATTENTION_YOUTUBE]?.isFinish,
                uncomplate: {
                    desc: generatePointsText(actionPoints[PointsBehaviorValue.ATTENTION_YOUTUBE]?.value, 'youtube_desc2'),
                    // button: locale !== 'jp' ? t('follow_button') : t('follow_button_youtube'),
                    button: t('youtube_title'),
                    onClick: () => {},
                },
            };

            const facebook = {
                key: PointsBehaviorValue.ATTENTION_FACEBOOK,
                title: t('facebook_title'),
                text: generatePointsText(actionPoints[PointsBehaviorValue.ATTENTION_FACEBOOK]?.value, 'facebook_desc1'),
                highlighttext: t('facebook'),
                icon: <RightFacebook />,
                isFinish: !!actionPoints[PointsBehaviorValue.ATTENTION_FACEBOOK]?.isFinish,
                uncomplate: {
                    desc: generatePointsText(actionPoints[PointsBehaviorValue.ATTENTION_FACEBOOK]?.value, 'facebook_desc2'),
                    // button: t('follow_button'),
                    button: t('facebook_title'),
                    onClick: () => {},
                },
            };

            const line = {
                key: PointsBehaviorValue.ATTENTION_LINE,
                title: t('line_title'),
                text: generatePointsText(actionPoints[PointsBehaviorValue.ATTENTION_LINE]?.value, 'line_desc1'),
                highlighttext: t('line'),
                icon: <RightFollow />,
                isFinish: !!actionPoints[PointsBehaviorValue.ATTENTION_LINE]?.isFinish,
                uncomplate: {
                    desc: generatePointsText(actionPoints[PointsBehaviorValue.ATTENTION_LINE]?.value, 'line_desc2'),
                    // button: t('follow_button2'),
                    button: t('line_title'),
                    onClick: () => {},
                },
            };

            const kakoo = {
                key: PointsBehaviorValue.ATTENTION_KAKOO,
                title: t('kakoo_title'),
                text: generatePointsText(actionPoints[PointsBehaviorValue.ATTENTION_KAKOO]?.value, 'kakoo_desc1'),
                highlighttext: t('kakoo_desc1'),
                icon: <RightKakoo />,
                isFinish: !!actionPoints[PointsBehaviorValue.ATTENTION_KAKOO]?.isFinish,
                uncomplate: {
                    desc: generatePointsText(actionPoints[PointsBehaviorValue.ATTENTION_KAKOO]?.value, 'kakoo_desc2'),
                    // button: t('follow_button'),
                    button: t('kakoo_title'),
                    onClick: () => {},
                },
            };

            const joininfacebook = {
                key: PointsBehaviorValue.JOIN_FACEBOOK,
                title: t('joininfacebook_title'),
                text: generatePointsText(actionPoints[PointsBehaviorValue.JOIN_FACEBOOK]?.value, 'joininfacebook_desc1'),
                highlighttext: t('joininfacebook'),

                icon: <RightFacebook />,
                isFinish: !!actionPoints[PointsBehaviorValue.JOIN_FACEBOOK]?.isFinish,
                uncomplate: {
                    desc: generatePointsText(actionPoints[PointsBehaviorValue.JOIN_FACEBOOK]?.value, 'joininfacebook_desc2'),
                    button: t('joininfacebook_title'),
                    onClick: () => {},
                },
            };

            const actionsSet = [instagram, x, youtube, facebook, line, kakoo, joininfacebook];
            const finalData = actionsSet.filter((item) => actionPoints[item.key]);

            const [c1] = dataForSlide(defaultData.concat(finalData));

            if (c1) {
                c1.forEach((element) => {
                    const isBelong = actionsSet.find((item) => item.key === element.key);
                    if (isBelong) {
                        element.uncomplate.onClick = () => cmdFunc[PointsBehaviorValue[element.key]]();
                    }
                });
            }

            setSlideData(dataForSlide(defaultData.concat(finalData)));
        }
    }, [actionPoints]);

    useEffect(() => {
        const type = router?.query[newWayType];

        // 点击对应行为，登录返回后若没完成积分任务进行对应操作
        if (type) {
            if (type === 'subscribe') {
                !subscribeIsFinish && setSubscribeModalOpen(true);
            } else if (type === 'warranty') {
                !warrantyIsFinish && router.push(`/${locale}/support/warranty`);
            } else if (type === 'profile') {
                !profileIsFinish && router.push(`/${locale}/my-overview`);
            } else if (type === 'instagram') {
                if (!instagramIsFinish) {
                    setTimeout(() => {
                        cmdFunc[PointsBehaviorValue.ATTENTION_INSTAGRAM]();
                    }, 500);
                }
            } else if (type === 'x') {
                if (!xIsFinish) {
                    setTimeout(() => {
                        cmdFunc[PointsBehaviorValue.ATTENTION_X]();
                    }, 500);
                }
            } else if (type === 'youtube') {
                if (!youtubeIsFinish) {
                    setTimeout(() => {
                        cmdFunc[PointsBehaviorValue.ATTENTION_YOUTUBE]();
                    }, 500);
                }
            } else if (type === 'facebook') {
                if (!facebookIsFinish) {
                    setTimeout(() => {
                        cmdFunc[PointsBehaviorValue.ATTENTION_FACEBOOK]();
                    }, 500);
                }
            } else if (type === 'joinfacebook') {
                if (!jFackbookIsFinish) {
                    setTimeout(() => {
                        cmdFunc[PointsBehaviorValue.JOIN_FACEBOOK]();
                    }, 500);
                }
            } else if (type === 'line') {
                if (!lineIsFinish) {
                    setTimeout(() => {
                        cmdFunc[PointsBehaviorValue.ATTENTION_LINE]();
                    }, 500);
                }
            } else if (type === 'kakoo') {
                if (!kakooIsFinish) {
                    setTimeout(() => {
                        cmdFunc[PointsBehaviorValue.ATTENTION_KAKOO]();
                    }, 500);
                }
            }
            removeQueryParam();
        }
    }, [
        subscribeIsFinish,
        warrantyIsFinish,
        profileIsFinish,
        instagramIsFinish,
        xIsFinish,
        youtubeIsFinish,
        facebookIsFinish,
        jFackbookIsFinish,
        lineIsFinish,
        kakooIsFinish,
        router,
        locale,
    ]);

    const initSwiper = () => {
        // 动态修改按钮的字号的padding,de的文案太长，运营还不肯换文案，没办法，嗐~
        // 延迟一秒，不然获取不到第二页的元素
        setTimeout(() => {
            setTheStyles();
        }, 50);
    };

    const setTheStyles = () => {
        if (isMobile) {
            const btnList = document.querySelectorAll('.ecocredits-points-wrapper .item .wtee-btn');

            const itemWrap: any = document.querySelector('.ecocredits-points-wrapper .item');
            if (itemWrap) {
                const wrapWidth = itemWrap.offsetWidth;
                if (btnList && btnList?.length > 0) {
                    btnList.forEach((ele: any) => {
                        const btnWidth = ele?.getBoundingClientRect()?.width || 0;
                        const btnHeight = ele?.getBoundingClientRect()?.height || 0;
                        // 假设按钮高度太高，超过3行，也修改一下
                        if (btnWidth >= wrapWidth || btnHeight > 50) {
                            ele.style.fontSize = '11px';
                            ele.style.padding = '4px 6px';
                        }
                    });
                }
            }
        }
    };

    useEffect(() => {
        if (typeof window !== 'undefined') {
            setIsClient(true);
        }
    }, []);

    return (
        <>
            <div
                className={`${css.ways_to_earn_points} GtmModuleData-section`}
                data-section-id={'Member-WaysToEarnPoints'}
                data-section-title={t('earn_points_title')}
                id={pageId}
            >
                <div className="ecocredits-over"></div>
                <h5 className="title">
                    {t('earn_points_title')}
                    <Link href={`https://${locale}.ecoflow.com/pages/rewards-guide`}>
                        <EFQuestionMark2 />
                    </Link>
                </h5>
                <div className="swiper-wrapper ecocredits-points-wrapper">
                    <Swiper
                        modules={[Navigation, Pagination]}
                        className="card-swiper"
                        pagination={{
                            clickable: true,
                        }}
                        slidesPerView={1}
                        initialSlide={0}
                        spaceBetween={0}
                        centeredSlides={true}
                        navigation={true}
                        onSlideChange={handleSlideChange}
                        onSwiper={(swiperIns) => setSwiper(swiperIns)}
                        onInit={initSwiper}
                    >
                        {slideData?.map((card: any, k: number) => (
                            <SwiperSlide className={`swiper-item item-${k + 1}`} key={k}>
                                <ul className="list">
                                    {card.map((item: any, k2: number) => {
                                        return (
                                            <li key={item.key} className={`item item-li-${k2} ${!!statusMap[item.key] && 'right'}`}>
                                                <div className="basic">
                                                    {!statusMap[item.key] ? (
                                                        <>
                                                            <div className="icon">{item.icon}</div>
                                                            <div className="content">
                                                                <p className="item-text">{item.text}</p>
                                                                {k > 0 ? (
                                                                    <Button className="wtee-btn" onClick={cmdFunc[item.key]}>
                                                                        {item?.uncomplate?.button}&nbsp;{`>>`}
                                                                    </Button>
                                                                ) : (
                                                                    <Button
                                                                        className="wtee-btn"
                                                                        onClick={() => item?.uncomplate?.onClick && item.uncomplate.onClick()}
                                                                    >
                                                                        {item?.uncomplate?.button}&nbsp;{`>>`}
                                                                    </Button>
                                                                )}
                                                            </div>
                                                        </>
                                                    ) : (
                                                        <>
                                                            <div className="icon right">
                                                                <RightIcon />
                                                            </div>
                                                            <div className="content">
                                                                <h5 className="item-right-title">{item.title}</h5>
                                                                <p className="item-right-text">{item.highlighttext}</p>
                                                            </div>
                                                        </>
                                                    )}
                                                </div>
                                            </li>
                                        );
                                    })}
                                </ul>
                            </SwiperSlide>
                        ))}
                    </Swiper>
                    <div className="swipwe-btn-container">
                        <button className={`swiper-button-prev swipwe-btn ${activeIndex === 0 ? 'disabled' : ''}`} onClick={handlePrev}></button>
                        <button
                            className={`swiper-button-next swipwe-btn ${activeIndex === slideData.length - 1 ? 'disabled' : ''}`}
                            onClick={handleNext}
                        ></button>
                    </div>
                </div>
            </div>

            <EfModal className={css.efmodal} visible={profileModalOpen} onCancel={() => setProfileModalOpen(false)} zIndex={1200}>
                <div className="note-content">
                    <h4 className="rule-title">{t('profile_a')}</h4>
                    <p className="rule-desc">{t('profile_detail')}</p>
                </div>
            </EfModal>

            <SubscribeModal open={subscribeModalOpen} closeModal={() => setSubscribeModalOpen(false)} onSuccess={() => pollingData()} />

            {isClient &&
                showLoginModal &&
                createPortal(
                    <LoginFormModal
                        visible={showLoginModal}
                        onCancel={() => {
                            setShowLoginModal(false);
                        }}
                        type="passwordless"
                    />,
                    document.body,
                )}

            {isClient &&
                showLoginModal1 &&
                createPortal(
                    <LoginFormModal
                        visible={showLoginModal1}
                        onCancel={() => {
                            setShowLoginModal1(false);
                        }}
                        type="passwordless"
                        isRegister={true}
                    />,
                    document.body,
                )}
        </>
    );
};

export default WaysToEarnPoints;
